import Fuse from 'fuse.js';

class FuseWrapper {
    constructor(jsonData) {
        console.log('FuseWrapper constructor');

        // Filter jsonData first for items that are not deleted and are published
        const filteredData = Object.keys(jsonData).reduce((accumulator, key) => {
            const item = jsonData[key];
            if (item.isDeleted !== true && item.contentStatus === 'published') {
                // Dynamically process all categories
                const categoriesContent = this.extractCategoriesData(item.categories);
                const keywordsContent = this.extractKeywordsData(item.extractData);

                accumulator[key] = {
                    ...item,
                    categoriesContent, // Add processed categories content for searching
                    keywordsContent, // Add CMS extract keywords for metadata search
                    contentData: this.extractRawData(item.contentData),
                };
            }
            return accumulator;
        }, {});

        const processedData = Object.keys(filteredData).length !== 0 ? Object.values(filteredData) : [];

        console.log(`processed data length: ${processedData.length}`);

        // CETRA-819: contentData (full handout body) is deliberately excluded from Fuse's fuzzy
        // keys. Fuzzy matching over long free text is unreliable — it produces false positives
        // (e.g. a "sheep" handout that incidentally mentions "dog" matching a "dog" search).
        // Search matches on title, alphabetical name, categories, CMS extract keywords, and content ID only.
        const fuseOptions = {
            keys: [
                { name: 'contentName', weight: 2.0 },
                { name: 'alphabeticalName', weight: 1.9 },
                { name: 'categoriesContent', weight: 1.7 },
                { name: 'keywordsContent', weight: 1.6 },
                { name: 'contentId', weight: 1.0 },
            ],
            includeScore: true,
            threshold: 0.3,
            location: 0,
            distance: 100,
            ignoreLocation: true,
        };

        this.fuse = new Fuse(processedData, fuseOptions);
    }

    extractCategoriesData(categories) {
        // Assuming each category is an object with similar structure to Body Area
        let categoriesData = '';
        for (const category in categories) {
            const categoryData = categories[category];
            // Concatenate the data from each category
            categoriesData += ' ' + this.extractRawData(categoryData);
        }
        return categoriesData.trim();
    }

    extractKeywordsData(extractData) {
        if (!extractData || typeof extractData !== 'object') return '';
        if (typeof extractData.keywords === 'string') return extractData.keywords.trim();

        return Object.values(extractData)
            .map((localeExtract) => {
                if (typeof localeExtract === 'string') return localeExtract;
                if (localeExtract && typeof localeExtract === 'object') return localeExtract.keywords || '';
                return '';
            })
            .filter(Boolean)
            .join(' ')
            .trim();
    }

    stripCmsTags(block) {
        switch (block.type) {
            case 'documentTitle':
            case 'sectionTitle':
            case 'calloutSmall':
            case 'calloutMedium':
            case 'paragraph':
                return block.value || '';
            case 'list':
                return (block.values && block.values.join(' ')) || '';
            case 'iconStrip':
                return (block.iconDetails && block.iconDetails.map((icon) => icon.caption).join(' ')) || '';
            case 'illustration':
                return block.alt || '';
            default:
                return '';
        }
    }

    extractRawData(data) {
        if (typeof data === 'object' && data['en-UK']) {
            const rawData = [];
            data['en-UK'].forEach((section) => {
                if (Array.isArray(section.blocks)) {
                    section.blocks.forEach((block) => {
                        rawData.push(this.stripCmsTags(block));
                    });
                }
            });
            return rawData.join(' ');
        } else if (typeof data === 'object') {
            return Object.values(data).join(' ');
        }
        return '';
    }

    searchContentMeta(query) {
        console.warn('test', query);
        const results = this.fuse.search(query);
        //console.log(`searchContentMeta results: ${JSON.stringify(results)}`);
        return (
            results
                // Filter out results with isDeleted === true
                .filter((result) => !(result.item.isDeleted === true))
                .map((result) => ({
                    contentId: result.item.contentId,
                    contentName: result.item.contentName,
                }))
        );
    }
}

export default FuseWrapper;
